import React from 'react';
import { Clock, LogOut, RefreshCw } from 'lucide-react';

export default function AdminTimeoutModal({ countdown, onStay, onLogout }) {
  const mins = Math.floor(countdown / 60);
  const secs = countdown % 60;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4 text-center">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Clock size={32} className="text-amber-500" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Session Expiring Soon</h2>
        <p className="text-gray-500 text-sm mb-6">
          You've been inactive. Your session will expire in:
        </p>
        <div className="text-5xl font-mono font-bold text-amber-500 mb-8 tabular-nums">
          {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
        </div>
        <div className="flex gap-3">
          <button
            onClick={onLogout}
            className="flex-1 flex items-center justify-center gap-2 border border-gray-300 text-gray-700 hover:bg-gray-50 px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors"
          >
            <LogOut size={15} /> Log Out
          </button>
          <button
            onClick={onStay}
            className="flex-1 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors"
          >
            <RefreshCw size={15} /> Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
}
